import { Controller } from "@hotwired/stimulus";

// Replaces searchfield_functions.ts's quick_link_click (legacy jQuery),
// gated off on rebuilt pages along with the rest of Searchfield.load(). The
// origin field's id/hidden-id pair is fixed (leg 0 only -- quicklinks only
// ever appear next to the single/return searchfield's origin field), so
// targeting by id matches the legacy behavior exactly.
export default class extends Controller {
  select(event) {
    event.preventDefault();
    const link = event.currentTarget;
    const originText = document.getElementById("search_legs_0_origin_text");
    const originId = document.getElementById("search_legs_0_origin_id");
    const destinationText = document.getElementById("search_legs_0_destination_text");
    if (originText) originText.value = link.dataset.text;
    if (originId) originId.value = link.dataset.id;
    if (destinationText) destinationText.focus();
  }
}
